// extracted by mini-css-extract-plugin
module.exports = {"button":"Button-module--button--2X_Ir"};